import "./UserMenuComponent.scss";
import {useCallback, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {StateParams} from "../../../store/reducers";
import {logoutUser} from "../../../store/actions/auth.action";
import {closeLoginModal} from "../../../store/actions/meta.action";

interface UserMenuComponentProps{

}

const UserMenuComponent=(props:UserMenuComponentProps)=>{
    const [userMenuVisible, setUserMenuVisible] = useState<boolean>(false);
    const {user}=useSelector((state:StateParams)=>state.auth);
    const dispatch=useDispatch();

    const toggleUserMenu = useCallback(() => {
        setUserMenuVisible(prev => !prev);
    }, []);

    const getUserInitials = () => {
        if (!user) return 'U';
        const firstName = user.firstName || user.first_name || '';
        const lastName = user.lastName || user.last_name || '';
        return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || user.email?.charAt(0).toUpperCase() || 'U';
    };

    const getUserDisplayName = () => {
        if (!user) return 'User';
        return `${user.firstName || user.first_name || ''} ${user.lastName || user.last_name || ''}`.trim() || user.email || 'User';
    };

    const handleLogout=useCallback(()=>{
        dispatch(logoutUser());
        dispatch(closeLoginModal())
    },[dispatch])

    return (
        <div className={'job-header-user-wrapper'}>
            <div className={'user-info-section'}>
                <span className={'welcome-text'}>Welcome back,</span>
                <span className={'user-name'}>{getUserDisplayName()}</span>
            </div>
            <div className={'user-actions-section'}>
                <div className={'user-menu-container'}>
                    <div className={'user-avatar'} onClick={toggleUserMenu}>
                        <span className={'avatar-initials'}>{getUserInitials()}</span>
                        <svg
                            className={`dropdown-arrow ${userMenuVisible ? 'rotated' : ''}`}
                            width="12"
                            height="8"
                            viewBox="0 0 12 8"
                            fill="none"
                        >
                            <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                  strokeLinejoin="round"/>
                        </svg>
                    </div>
                    {userMenuVisible && (
                        <div className={'user-dropdown-menu'}>
                            <div className={'dropdown-item logout-item'} onClick={handleLogout}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                     strokeWidth="2">
                                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                                    <polyline points="16,17 21,12 16,7"/>
                                    <line x1="21" y1="12" x2="9" y2="12"/>
                                </svg>
                                Sign Out
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default UserMenuComponent